import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Outlet} from '@github-ui/react-router'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {ReposIssuesSidebar} from '@github-ui/repos-issues-sidebar/ReposIssuesSidebar'
import {useMemo, type ReactNode} from 'react'

import {issuesLayoutRoute} from './issues-layout-route'

type SidebarOptions = {
  owner: string
  repo: string
  hasProjectsEnabled: boolean
  pinnedViewsIndexPageEnabled: boolean
  pinnedViewsProjectsReactEnabled: boolean
}

function renderSidebar(options: SidebarOptions) {
  return function IssuesSidebar(collapsible?: boolean): ReactNode {
    return <ReposIssuesSidebar collapsible={collapsible} {...options} />
  }
}

export function IssuesLayout() {
  const {owner, repo} = useRouteParams(issuesLayoutRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const hasProjectsEnabled = layoutPayload?.has_projects_enabled ?? false
  const pinnedViewsIndexPageEnabled = layoutPayload?.pinned_views_index_page_enabled ?? false
  const pinnedViewsProjectsReactEnabled = layoutPayload?.pinned_views_projects_react_enabled ?? false

  const renderSidebarFn = useMemo(() => {
    return renderSidebar({
      owner,
      repo,
      hasProjectsEnabled,
      pinnedViewsIndexPageEnabled,
      pinnedViewsProjectsReactEnabled,
    })
  }, [owner, repo, hasProjectsEnabled, pinnedViewsIndexPageEnabled, pinnedViewsProjectsReactEnabled])

  return (
    <BaseAnalyticsWrapper category={'Repository Label Index'} appName={'issues'}>
      <RepoIssuesPageLayout dialogTitle="Labels" title="Labels" renderSidebar={renderSidebarFn}>
        <Outlet />
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
